import { useState } from "react";
import { Select } from "antd";
import type { CSSProperties } from "react";

export interface TypeData {
  value: string | boolean;
  label: string;
}

function ActionDropdown({
  value,
  options,
  onChange,
  placeholder,
  style,
  className,
}: {
  value: any;
  options: TypeData[];
  onChange: (e: string | boolean) => void;
  placeholder: string;
  style?: CSSProperties;
  className?: string;
}) {
  const [hovered, setHovered] = useState(false);

  const formattedOptions = options?.map((item) => ({
    value: item.value,
    label: item.label,
  }));

  const selectValue = value === "" || value === undefined ? undefined : value;

  const handleChange = (newValue: string | boolean | undefined) => {
    onChange(newValue === undefined ? "" : newValue);
  };

  return (
    <div
      style={{ position: "relative", display: "inline-block" }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Select
        showSearch
        value={selectValue}
        filterOption={(input, option: any) =>
          option?.label?.toLowerCase()?.includes(input?.toLowerCase())
        }
        onChange={handleChange}
        className={`w-40 ${className || ""}`}
        placeholder={placeholder}
        allowClear
        options={formattedOptions}
        style={style}
      />

      {/* Custom hover box */}
      {hovered && (
        <div
          style={{
            position: "absolute",
            top: "100%", // just below Select
            left: 0,
            marginTop: "2px",
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "2px 6px",
            fontSize: "11px",
            color: "#000",
            whiteSpace: "nowrap",
            zIndex: 1000,
          }}
        >
          {placeholder}
        </div>
      )}
    </div>
  );
}

export default ActionDropdown;
